const config = {
    DOMAIN: 'http://localhost:3000',
    LOGO: 'https://dev-interviewer-ai-assets.s3.amazonaws.com/Interviewer-ai-logo-transparent-128x128.png',
};

export default config;